import type { BankAccountDocumentType } from 'v2/components/Pages/AddBankAccount/Stepper/form';

export enum EFromPageTransfer {
  NEW_CARD = 'new_card',
  OLD_CARD = 'old_card'
}

export enum CurrencyId {
  BRL = 1,
  USD = 2
}

export enum BankAccountDisappovalReasonId {
  NON_LEGIBLE_DOCUMENT = 1,
  NON_LEGIBLE_BANK_RECEIPT = 2,
  NO_VIDEO = 3,
  NO_VIDEO_DOCUMENT = 4,
  CPF_DIFFERENT_DOCUMENT = 5,
  NAME_DIFFERENT_DOCUMENT = 6,
  BANK_RECEIPT_DIFFERENT_ACCOUNT_BANK = 7,
  BANK_RECEIPT_DIFFERENT_BANK = 8,
  NO_BANK_RECEIPT = 9,
  CPF_DIFFERENT_ACCOUNT_BANK = 10,
  JUDICIAL_LIQUIDATION = 11,
  ACCOUNT_BANK_LEGAL_PERSON = 12,
  UPDATE_PHYSICAL_PERSON = 13,
  UPDATE_PHYSICAL_PERSON_CPF = 14,
  CHANGE_TO_PHYSICAL_PERSON = 15,
  NO_CNPJ = 16,
  CHANGE_TO_LEGAL_PERSON = 17,
  UPDATE_LEGAL_PERSON = 18,
  ACCOUNT_BANK_DIFFERENT = 19,
  UPDATE_ACCOUNT_BANK = 20,
  IRREGULAR_CNPJ = 21,
  TRANSFER_RETURNED = 22,
  ACCOUNT_BANK_THIRD_PARTY = 23,
  UPDATE_ACCOUNT_BANK_CPF = 24,
  ACCOUNT_BANK_THIRD_PARTY_CPF = 25,
  ACCOUNT_BANK_ONLY_TRANSFER = 26,
  ACCOUNT_BANK_CLOSED = 27,
  NEED_ACCOUNT_RECEIPT = 28,
  ACCOUNT_BANK_UPDATE_CPF = 29,
  UPDATE_ACCOUNT_BANK_UPDATE_ACCOUNT = 30,
  ACCOUNT_BANK_NO_CREDIT = 31,
  CNPJ_CLOSED = 32,
  ACCOUNT_BANK_CLOSED_REVERSAL = 33,
  NEED_PROCURATOR_DOCUMENT = 34,
  DOCUMENT_CORRUPTED = 35,
  NEED_EMANCIPATION_DOCUMENT = 36,
  UPDATE_NAME = 37,
  RETURNED_TRANSFER = 38,
  DUPLICITY_REGISTRATION = 39,
  INVALID_ACCOUNT_NUMBER = 40,
  INAPT_CNPJ = 41,
  DIFFERENT_CNPJ = 42,
  INAVLID_CNPJ = 43,
  UPDATE_NAME_EQUAL_CNPJ = 44,
  ACCOUNT_BANK_DIVERGENT_DATA = 46,
  NEED_BANK_RECEIPT = 47,
  UPDATE_ACCOUNT_BANK_DATA = 48,
  UPDATE_ACCOUNT_BANK_DATA_PLURAL = 49,
  NEED_ESTATUTO_SOCIAL = 50,
  BANK_RECEIPT_DIVERGENT = 51,
  INVALID_CNPJ = 52,
  UPDATE_ACCOUNT_BANK_EQUAL_DOCUMENT = 53,
  NEED_PHOTO_DOCUMENT = 54,
  CNPJ_BAIXA = 55,
  INVALID_DOCUMENT_NUMBER = 56,
  NEED_RG = 57,
  BANK_RECEIPT_DIVERGENT_NAME = 58,
  NEED_DOCUMENT_FRONT_BACK = 59,
  NEED_BANK_RECEIPT_REFUND = 60,
  NEED_CPF_EQUAL_ACCOUNT = 61,
  NEED_HOLDER_DOCUMENT = 62,
  BANK_RECEIPT_LEGAL_PERSON = 63,
  BACNK_ACCOUNT_DIVERGENT_CNPJ = 64,
  DOCUMENT_WITH_PASS = 65,
  NEED_BANK_RECEIPT_LEGAL_PERSON = 67,
  NEED_BANK_ACCOUNT_EQUAL_CNPJ = 68,
  BANK_ACCOUNT_DIVERGENT_CORPORATE_NAME = 69,
  CANCELLED_COURT_ORDER = 70,
  BANK_ACCOUNT_TEST = 71,
  NEED_BANK_RECEIPT_PAYMENT = 72,
  BANK_RECEIPT_DIVERGENT_CPF = 73,
  NEED_CPF = 74,
  NEED_TITULAR_BANK_RECEIPT = 75,
  UPDATE_ACCOUNT_BANK_EQUAL_DOCUMENTS = 76,
  DIVERGENT_BUSINESS_NAME = 77,
  NEED_OWNER_BANK_ACCOUNT_DOCUMENT = 78,
  NEED_DOCUMENTS_AND_UPDATE_BANK_ACCOUNT_DATA = 79,
  CHANGE_OWNERSHIP = 80
}

export interface ILoadAvailable {
  transfer: ITransferAvaliable;
  anticipation: IAnticipationAvaliable;
}

export type LoadAnticipation = {
  invoices: InvoiceToAnticipateItem[];
  availableAnticipation: number;
  availableTransfer: number;
};

type InvoiceToAnticipateItem = {
  id: number;
  gain: number;
  fee: number;
  selected: boolean;
  value: number;
  commissions: CommisionToAnticipateItem[];
};

type CommisionToAnticipateItem = {
  id: number;
  description: string;
  isSelectable: boolean;
  gain: number;
  fee: number;
  value: number;
};

interface ITransferAvaliable {
  avaliable: number;
}

interface IAnticipationAvaliable {
  avaliable: number;
  invoices: number[];
}

export interface SendTransferInvoice {
  transfer_key: string;
  transfer_method_id: number;
}

export interface ISendTransfer {
  value: number;
  transfer_method_id: number;
  commissions?: number[];
  from?: EFromPageTransfer;
}

export interface IBanklist {
  id: string;
  value: string;
}

export interface IOperationList {
  id: string;
  operation: string;
}

export interface IBankAccount {
  id: number;
  uuid: string;
  name: string;
  status_slug: string;
  main: boolean;
  document_number: string;
  bank_id: string;
  agency: string;
  agency_digit: string;
  account: string;
  account_digit: string;
  type: string;
  created_at: Date;
  annotation: null;
  status: string;
  currency: ICurrency;
  operation_id: string;
  reason_disapproval_id: number;
  reason_disapproval: string;
  account_nature: string;
  bank_receipt_image: number;
  document_image_type: BankAccountDocumentType;
  document_image_front: number;
  document_image_back: number;
  driver_license_image: number;
  address_image: number;
  personal_document_video: number;
}

export interface IBlockedExtract {
  description: string;
  value: number;
  origin_currency_value: number;
  note: string;
}

interface ICurrency {
  id: number;
  name: string;
  code: string;
}

export interface IAvailable {
  available_antecipation: number;
  has_minimal: boolean;
  limited: boolean;
  origin_total_value: number;
  origin_value: number;
  total_value: number;
  value: number;
}

export interface INewAccount {
  currency: CurrencyId;
  type: 'CC' | 'CP';
  bank_id: string;
  operation_id: string;
  document_number: string;
  name: string;
  agency: string;
  agency_digit: string;
  account: string;
  account_digit: string;
  imgsIds?: any;
  notes?: string;

  //usado para enviar para a api
  driver_license_image?: number;
  tax_document_image?: number;
  personal_document_image?: number;
  personal_document_video?: number;
  address_image?: number;
}

export interface IRefundBankAccount {
  invoice_id: string;
  has_bank_account_registered: boolean;
  name: string;
  document_number: string;
  bank_id: string;
  agency: string;
  agency_digit: string;
  account: string;
  account_digit: string;
  currency: CurrencyId;
  operation_id: string;
  type: 'CC' | 'CP';
}

export interface IAnticipationPromotion {
  isActive: boolean;
  value: number;
}

export interface IFinancialEntry {
  positive?: number;
  negative?: number;
  balance: number;
  items: number;
  transaction_date: string;
}

export interface IFinancialInvoice {
  invoice_id: number;
  description: string;
  amount: number;
  is_chargeback: boolean;
  is_installment_settlement: boolean;
}

export enum MovementsType {
  ALL = '',
  ENTRY = 'ENTRY',
  OUT = 'OUT'
}

export type FinancialStatementFilter = {
  periodPreset: string;
  dates?: string[];
  transacted_at_initial?: string;
  transacted_at_final?: string;
  movement_type: MovementsType;
  transaction_type: TransactionsType;
  search_type?: SearchType;
  search_text?: string;
};

export type FinancialStatementEntry = {
  balance: number;
  items: number;
  transaction_date: string;
};

export type FinancialStatementEntryDetails = {
  amount: number;
  description: number;
  invoice_id: string;
};

export type AddBankAccountModel = {
  account_nature: 'F' | 'J';
  currency: CurrencyId;
  type: 'CC' | 'CP';
  bank_id: string;
  operation_id: string;
  document_number: string;
  name: string;
  agency: string;
  agency_digit: string;
  account: string;
  account_digit: string;
  notes?: string;
  tax_document_image?: number;
  driver_license_image?: number;
  personal_document_image_front?: number;
  personal_document_image_back?: number;
  professional_identity_image_front?: number;
  professional_identity_image_back?: number;
  personal_document_video?: number;
  address_image?: number;
};

export enum EFinancialStatementTabs {
  STATEMENT = 'statement',
  FUTURE = 'future',
  BLOCKED = 'blocked'
}

export type SomeFinancialStatementTabs =
  EFinancialStatementTabs.BLOCKED | EFinancialStatementTabs.FUTURE | EFinancialStatementTabs.STATEMENT;

export type TransferHistoryEntry = {
  id: number;
  can_export_transfer_data: boolean;
  solicitation_date: string;
  conclusion_date: string;
  value: number;
  status_id: number;
  status_name: string;
  antifraud_status_name: string;
};

export enum TransferStatus {
  CONFIRMADA = 1,
  CANCELADA = 2,
  PENDENTE = 4,
  ANDAMENTO = 6,
  BLOQUEADA = 7,
  PROCESSAMENTO = 9,
  FALHOU = 11
}

export const friendilyAntifraudStatus = {
  'Cancelado': 'Falha na transferência.',
  'Suspeito': 'Necessário comprovação de vendas.',
  'Cancelado Vendas Suspeitas': 'Necessário comprovação de vendas.',
  'Cancelado Código de Rastreio': 'Necessário o envio de Código de Rastreio.',
  'Cancelado Solicitação do Cliente': 'Operação de transferência cancelada pelo usuário.'
};

export enum TransactionsType {
  ALL = '',
  ANTICIPATION = 'anticipation',
  CHARGEBACK = 'chargeback',
  CREDITS = 'credits',
  EARNINGS = 'earnings',
  REVERSAL = 'reversal',
  BILLING = 'billing',
  FEES = 'fees',
  TRANSFERS = 'transfers',
  REFUND = 'refund',
  INSTALLMENT_SETTLEMENT = 'installment_settlement',
  OTHERS = 'others'
}

export type BodyExportRequest = {
  start_date: string;
  end_date: string;
  email: string;
  export_in_future: boolean;
  export_blocked: boolean;
};

export enum SearchType {
  ALL = '',
  INVOICE = 'invoice_id',
  PRODUCT = 'product_id',
  NAME = 'customer_name',
  EMAIL = 'customer_email',
  DOCUMENT = 'customer_document'
}
